import React from 'react';
import styled from 'styled-components';
import SystemAlertColumnInfo from './component/systemAlert/SystemAlertColumnInfo';
import SystemAlertList from './component/systemAlert/SystemAlertList';



const AdminSystemAlert: React.FC = () => {
  return (
    <>
      <SystemAlertContainer>
        <SystemAlertColumnInfo />
        <SystemAlertList />
      </SystemAlertContainer>
    </>
  )
}

const SystemAlertContainer = styled.main`
  width: 96%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: calc(8vh);
  margin-bottom: 5.8vh ;
  overflow: hidden;
`;

export default AdminSystemAlert;
